import React, { Component } from 'react';
import { connect } from 'react-redux';
import SectorsTree from '../components/SectorsTreeComponents/SectorsTreeComponent';
import { actions } from '../actions/sectorsActions';
import { selectors } from '../reducers/sectorsReducer';
import { selectors as appSelectors } from '../reducers/appReducer';
import { getFilterFromLocalStorage } from '../utils/LocalStorageFilterUtils';

class SectorsTreeContainer extends Component {
    render() {
        return <SectorsTree {...this.props} />;
    }
}

function mapStateToProps(state) {
    return {
        data: selectors.getTree(state),
        language: appSelectors.getLanguage(state),
        selectedItem: selectors.getSelectedItem(state),
        isFetching: selectors.getIsFetching(state),
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onItemClick: (id, depth) => {
            const isEtim = getFilterFromLocalStorage('etim_class')

            if (isEtim === null) {
                ownProps.onChange('classification_path', { id, depth })
            } else {
                //console.log('Here we can change the etimClass')
                ownProps.onChange('etim_class', { id, depth })
            } /*else {
                dispatch(actions.toggleTreeItem(id, depth));
            }*/
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SectorsTreeContainer);